export enum Workflows {
    listings = 'listings',
    inventory = 'inventory',
    shipping = 'shipping',
    performance = 'performance',
    support = 'support',
    fees = 'fees',
    chargebacks = 'chargebacks',
    ads = 'ads',
    pricing = 'pricing',
    compliance = 'compliance',
    listingQuality = 'listingQuality',
    salesTraffic = 'salesTraffic',
    listingAssets = 'listingAssets',
    salesCurrent = 'salesCurrent',
    respondToCustomerMessages = 'respondMessages',
    manageReviews = 'manageReviews',
    fixInventory = 'fixInventory',
    sellingApplications = 'sellingApplications',
    brand = 'brand',
    payment = 'payment',
    purchaseOrders = 'purchaseOrders',
    sellerCentralPlatform = 'sellerCentralPlatform',
    vendorCentralPlatform = 'vendorCentralPlatform',
}

export enum CategoryStringId {
    adsPolicy = 'vibes_category_adspolicy',
    adsUI = 'vibes_category_adsui',
    amazon = 'vibes_category_amazon',
    chargebackPolicy = 'vibes_category_chargebackpolicy',
    chargebackUI = 'vibes_category_chargebackui',
    compliancePolicy = 'vibes_category_compliancepolicy',
    complianceUI = 'vibes_category_complianceui',
    customerservice = 'vibes_category_customerservice',
    feedbackPolicy = 'vibes_category_feedbackpolicy',
    feedbackUI = 'vibes_category_feedbackui',
    feesPolicy = 'vibes_category_feespolicy',
    feesUI = 'vibes_category_feesui',
    inventoryPolicy = 'vibes_category_inventorypolicy',
    inventoryUI = 'vibes_category_inventoryui',
    listingPolicy = 'vibes_category_listingpolicy',
    listingQualityPolicy = 'vibes_category_listingqualitypolicy',
    listingQualityUI = 'vibes_category_listingqualityui',
    listingUI = 'vibes_category_listingui',
    messagingPolicy = 'vibes_category_messagingpolicy',
    messagingUI = 'vibes_category_messagingui',
    performancePolicy = 'vibes_category_performancepolicy',
    performanceUI = 'vibes_category_performanceui',
    pricingPolicy = 'vibes_category_pricingpolicy',
    pricingUI = 'vibes_category_pricingui',
    psasPolicy = 'vibes_category_psaspolicy',
    psasUI = 'vibes_category_psasui',
    salesPolicy = 'vibes_category_salespolicy',
    salesUI = 'vibes_category_salesui',
    shippingPolicy = 'vibes_category_shippingpolicy',
    shippingUI = 'vibes_category_shippingui',
    shipmentIssuesTools = 'vibes_category_shipment_issues',
    shipmentPrepPolicy = 'vibes_category_shipment_prep',
    sellingApprovalTools = 'vibes_category_approval_tools',
    sellingApprovalPolicy = 'vibes_category_approval_policy',
    brandTools = 'vibes_category_brand_tools',
    brandPolicy = 'vibes_heading_growbrandpolicy',
    paymentTools = 'vibes_category_paymentstatusui',
    paymentPolicy = 'vibes_category_paymentstatuspolicy',
    purchaseOrdersTools = 'vibes_category_poui',
    purchaseOrdersPolicy = 'vibes_category_popolicy',
    sellerCentralPlatformPolicy = 'vibes_category_scpolicy',
    sellerCentralPlatformTools = 'vibes_category_sctools',
    vendorCentralPlatformPolicy = 'vibes_category_vcpolicy',
    vendorCentralPlatformTools = 'vibes_category_vctools',
}

export enum FeedbackCategories {
    ui = 'User Interface',
    policy = 'Policy',
    customService = 'Customer Service Interaction',
    workingWithAmazon = 'Working with Amazon',
}
export enum HeadingStringId {
    ads = 'vibes_heading_ads',
    chargebacks = 'vibes_heading_chargebacks',
    compliance = 'vibes_heading_compliance',
    fees = 'vibes_heading_fees',
    inventory = 'vibes_heading_inventory',
    listing = 'vibes_heading_listing',
    listingAssets = 'vibes_heading_listingassets',
    listingQuality = 'vibes_heading_listingquality',
    performance = 'vibes_heading_performance',
    pricing = 'vibes_heading_pricing',
    psas = 'vibes_heading_psas',
    respond = 'vibes_heading_respond',
    reviews = 'vibes_heading_reviews',
    salesCurrent = 'vibes_heading_salescurrent',
    salesTraffic = 'vibes_heading_salestraffic',
    shipping = 'vibes_heading_shipping',
    fixInventory = 'vibes_heading_fix_inventory',
    sellingApplications = 'vibes_heading_selling_applications',
    brand = 'vibes_heading_growbrand',
    payments = 'vibes_heading_paymentstatus',
    purchaseOrders = 'vibes_heading_po',
    sellerCentralPlatform = 'vibes_heading_sc',
    vendorCentralPlatform = 'vibes_heading_vc',
}
